import { type CSSProperties, forwardRef, type ReactNode, useCallback, useLayoutEffect, useRef } from 'react'
import { useElementSize } from '../hooks/useElementSize/useElementSize.ts'
import classes from './scrollable-container.module.css'

type Props = {
  style?: CSSProperties
  children: ReactNode
  onChangeHeight?: (height: number) => void
}

export const ScrollableContainer = forwardRef<HTMLDivElement, Props>(function ScrollableContainer(props, ref) {
  const { style = {}, children, onChangeHeight } = props

  const localRef = useRef<HTMLElement | null>(null)
  const { height } = useElementSize(localRef.current)

  const mergeRef = useCallback(
    (instance: HTMLDivElement | null) => {
      if (typeof ref === 'function') {
        ref(instance)
      } else if (ref) {
        ref.current = instance
      }

      localRef.current = instance
    },
    [ref],
  )

  useLayoutEffect(() => {
    onChangeHeight?.(height)
  }, [onChangeHeight, height])

  return (
    <div className={classes.root} style={style}>
      <div className={classes.inner} ref={mergeRef}>
        {children}
      </div>
    </div>
  )
})
